module.exports = __webpack_public_path__ + "static/img/CO2ePlacard.fda770c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CO2ePlacard.png
// module id = 121
// module chunks = 1